(ns app.front.query.core
  (:require [app.front.entities :as entities]
            [re-frame.core-instrumented :as rf]))

(defn handle-fetch [db command params]
  {:comm/command {:command    command
                  :data       params
                  :on-success [::fetch.success command params]}
   :db           (-> db
                     (update ::fetching #(conj (or % #{}) [command params])))})

(rf/reg-event-fx ::fetch
  (fn [{:keys [db]} [_ command & [params]]]
    (handle-fetch db command params)))

(rf/reg-event-fx ::fetch-once
  (fn [{:keys [db]} [_ command & [params]]]
    (when (and (-> db ::fetched (contains? [command params]) not)
               (-> db ::fetching (contains? [command params]) not))
      (handle-fetch db command params))))

(rf/reg-event-fx ::fetch.success
  (fn [{:keys [db]} [_ command params status data]]
    {:dispatch [::entities/merge-entity-db status data]
     :db       (-> db
                   (update ::fetched #(conj (or % #{}) [command params]))
                   (update ::fetching disj [command params]))}))

(rf/reg-sub ::fetching
  (fn [db _] (::fetching db #{})))

(rf/reg-sub ::fetching-query-ids
  :<- [::fetching]
  (fn [fetching _]
    (->> fetching
         (map first)
         set)))

(rf/reg-sub ::fetching?
  :<- [::fetching-query-ids]
  (fn [fetching [_ query-id]]
    (contains? fetching query-id)))
